import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { UpdateDatabaseListComponent } from './components/update-database-list/update-database-list.component';
const ɵ0 = {
    breadcrumb: 'Atualização de Base local'
};
const routes = [
    {
        path: 'updateDatabase/list',
        component: UpdateDatabaseListComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
    }
];
export class UpdateDatabaseRoutingModule {
}
export { ɵ0 };
